import { environment } from "@/config/environment"
import { siteConfig } from "@/config/site"

// import { theme } from "@/config/theme"

export const config = {
  environment,
  site: siteConfig,
  settings: {
    experimental: {},
  },
}
